/**
 * @author       Pavlo Androshchuk
 * @copyright    Copyright (c) 2022, Zumper
 */

import { selectGlobalNavAFRLinks } from '@zcode-ui/web-zumper-global-state'
import React, { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { TRACK_USER_MENU_ACTION } from '../../../../constants'
import { usePathname } from '../../../../hooks/usePathname'
import {
  type ExtraNavLink,
  getAFRMenuNavDefaultLinks,
  getMenuNavLinks,
} from '../../../../utils/getMenuNavLinks'
import { UserLinksSubmenu } from '../UserLinksSubmenu'

interface AFRUserSubmenuProps {
  onLinkClick: (name: string, href: string) => void
}

const EXTRA_LINKS = [
  {
    name: 'Near Me',
    href: '/near-me/apartments',
    title: 'Apartments Near Me',
    is_indexed: true,
    trackingName: TRACK_USER_MENU_ACTION.APARTMENTS_FOR_RENT_NEAR_ME,
  },
] as const satisfies ReadonlyArray<ExtraNavLink>

export const AFRUserSubmenu = ({ onLinkClick }: AFRUserSubmenuProps) => {
  const pathName = usePathname()
  const getLocaleLinkTitle = useCallback((name: string) => `Apartments for rent ${name}`, [])
  const afrLinks = useSelector(selectGlobalNavAFRLinks)
  const links = useMemo(
    () =>
      afrLinks?.length > 0
        ? getMenuNavLinks('/apartments-for-rent/', afrLinks, 15, pathName)
        : getAFRMenuNavDefaultLinks(pathName),
    [afrLinks, pathName]
  )
  return (
    <UserLinksSubmenu
      extraLinks={EXTRA_LINKS}
      getLocaleLinkTitle={getLocaleLinkTitle}
      links={links}
      onLinkClick={onLinkClick}
    />
  )
}
